module.exports = __webpack_public_path__ + "img/satel.ad6f28ae.png";